"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _Styles = require("../utils/Styles");

var _decorators = require("../utils/propTypes/decorators");

var _DialogConstants = require("./DialogConstants");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  width: ", ";\n\n  @media only screen and (min-width: ", ") {\n    top: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ABOVE_MOBILE_BREAKPOINT = (0, _Styles.toPx)(parseInt(_sizes.GRID_BREAKPOINT_SMALL, 10) + 1);

var Div = _styledComponents.default.div.withConfig({
  displayName: "UIDialog__Div",
  componentId: "axmggl-0"
})(_templateObject(), function (_ref) {
  var _dialogWidth = _ref._dialogWidth;
  return (0, _Styles.toPx)(_dialogWidth);
}, ABOVE_MOBILE_BREAKPOINT, function (_ref2) {
  var headerOverflow = _ref2.headerOverflow;
  return (0, _Styles.toPx)(headerOverflow);
});

var UIDialog =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UIDialog, _React$Component);

  function UIDialog() {
    (0, _classCallCheck2.default)(this, UIDialog);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIDialog).apply(this, arguments));
  }

  (0, _createClass2.default)(UIDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          centered = _this$props.centered,
          children = _this$props.children,
          className = _this$props.className,
          use = _this$props.use,
          size = _this$props.size,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["centered", "children", "className", "use", "size"]);
      return _react.default.createElement(Div, (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)('private-modal', _DialogConstants.DIALOG_USE_CLASSES[use], _DialogConstants.SIZE_CLASSES[size], 'uiDialog-root', className, {
          'private-modal--centered': centered
        })
      }), children);
    }
  }]);
  return UIDialog;
}(_react.default.Component);

UIDialog.propTypes = {
  _dialogWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  centered: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node,
  headerOverflow: (0, _decorators.hidden)(_propTypes.default.number),
  size: _propTypes.default.oneOf(Object.keys(_DialogConstants.SIZE_CLASSES)),
  use: _propTypes.default.oneOf(Object.keys(_DialogConstants.DIALOG_USE_CLASSES))
};
UIDialog.defaultProps = {
  centered: false,
  size: 'medium',
  use: 'default'
};
UIDialog.displayName = 'UIDialog';
UIDialog.Selector = Div;
var _default = UIDialog;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/dialog/UIDialog.js
// module id = 407
// module chunks = 5 6